import { render, staticRenderFns } from "./ImportMassDocuments.vue?vue&type=template&id=dd8879da&"
import script from "./ImportMassDocuments.vue?vue&type=script&lang=js&"
export * from "./ImportMassDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports